import { all } from 'redux-saga/effects';

import patientSaga from './patient-saga';

export default function* rootSaga() {
  yield all([patientSaga()]);
}
